import PropTypes from 'prop-types';

const TextFilter = ({ config, onChange, value }) => {
  return (
    <div className={`filter ${config.hidden ? 'hidden' : ''}`}>
      <label htmlFor={config.field}>{config.label}</label>
      <input
        id={config.field}
        type='text'
        name={config.field}
        placeholder={config.placeholder}
        onChange={onChange}
        value={value}
        className='filter-input'
      />
    </div>
  );
};

TextFilter.propTypes = {
  config: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};
TextFilter.defaultProps = {
  value: '',
};

export default TextFilter;
